import React from "react";
import Auth from "@rill/auth";
import LoginWrapper from "./LoginWrapper";

function View(props, { locals }) {
  const {
    params: { token },
  } = locals;
  return (
    <LoginWrapper
      left={
        <form method="POST" action="/actions/user/update-password" data-noreset>
          <div>
            <h1>Reset password</h1>
          </div>
          <input type="hidden" name="token" value={token} />
          <label htmlFor="password">Password</label>
          <input
            className="text-input"
            type="password"
            name="password"
            placeholder="Password"
            required
          />
          <label className="mt-4" htmlFor="confirmPassword">
            Confirm Password
          </label>
          <input
            className="text-input"
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            required
          />
          <button data-button-type="primary" sz="large" type="submit">
            Save Password
          </button>
        </form>
      }
    />
  );
}

const UpdatePassword = (app) => {
  app.get(
    "/update-password/:token",
    Auth.isLoggedOut({ redirect: "dashboard" }),
    ({ res }) => (res.body = <View />)
  );
};

export default UpdatePassword;
